import axios from "axios"
import { useUserStore } from "./stores/user-store"
import { useGlobalStore } from "./stores/global-store"
import router from "./router"

async function createAxiosInstance(baseURL: string, tokenType: string = "enriched") {
  const response = await fetch("/config.json")
  const config = await response.json()
  const store = useUserStore()
  const globalStore = useGlobalStore()

  const instance = axios.create({
    baseURL: baseURL,
    timeout: config.timeout,
  })

  instance.interceptors.request.use(
    (config) => {
      globalStore.showLoading()
      const token = tokenType === "enriched" ? store.user?.token : store.user?.accessToken

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    (error) => {
      globalStore.hideLoading()
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    (response) => {
      globalStore.hideLoading()
      return response
    },
    (error) => {
      globalStore.hideLoading()
      if (error.response?.status === 401) {
        router.push({ name: "home" })
      }
      if (error.response?.status === 403) {
        router.push({ name: "403" })
      }
      return Promise.reject(error)
    },
  )
  return instance
}

export default createAxiosInstance
